import { Container, Stack, Typography } from "@mui/material";
import { useParams } from "react-router";
import { DashboardLayout } from "../components/DashboardLayout/DashboardLayout";
import { InternalError } from "../components/Errors/InternalError";
import Loading from "../components/Loading";
import ChatInput from "../components/Sirius/ChatInput";
import ChatProfile from "../components/Sirius/ChatProfile";
import { useBot, useCreateChat } from "../components/Sirius/SiriusQueries";

function NewChatPage() {
  let params = useParams();
  const botId = params.botId as string;
  const { data: bot, isLoading, isError } = useBot(botId);

  const { mutate: createChat } = useCreateChat(
    bot as { id: string; name: string }
  );

  function getContent() {
    if (isError) {
      return <InternalError />;
    } else if (isLoading) {
      return <Loading />;
    } else {
      return (
        <Stack gap={4}>
          <div className="flex justify-center items-center">
            <ChatProfile fontSize="large" />
            <Typography className="font-bold text-2xl ml-2">
              Comment puis-je vous aider ?
            </Typography>
          </div>
          <ChatInput chatId={"new"} sendMessage={createChat} loading={false} />
        </Stack>
      );
    }
  }

  return (
    <DashboardLayout>
      <Container
        maxWidth={false}
        className="mx-auto flex h-full w-full flex-col text-base relative md:max-w-3xl lg:max-w-4xl txl:max-w-6xl justify-center"
      >
        {getContent()}
        <Typography className="w-full px-2 py-2 text-center text-xs md:px-[60px] absolute bottom-0 left-0">
          Notre chatbot peut faire des erreurs. Pensez à vérifier les
          informations importantes
        </Typography>
      </Container>
    </DashboardLayout>
  );
}

export default NewChatPage;
